import { UserContext } from "App";
import AccountingApi from "Classes/API/AccountingApi";
import AddManyToManyReq from "Classes/Models/Requests/AddManyToManyReq";
import SessionsTable from "layouts/AccountingSessions/SessionsTable";
import { useContext } from "react";
import Swal from "sweetalert2";

export default function StaySessionsTable({ stay, setStay, setIsLoaded, extra = false }) {
  const CurrentUser = useContext(UserContext);

  // const batchDeleteAccountingSessions = (accSessions) => {
  //   alert(JSON.stringify(accSessions, null, 1));
  // };
  const batchDeleteAccountingSessions = async (accSessions) => {
    if ((!["Admin", "Owner", "HeadAccounting"].includes(CurrentUser.userType))) {
      Swal.fire({
        title: "Error",
        text: "You are not authorized to delete accounting sessions",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      title: "Loading...",
      text: "Please wait",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      icon: "info",
    });
    let successCount = 0;
    let errorCount = 0;
    for (let i = 0; i < accSessions.length; i++) {
      let req = new AddManyToManyReq();
      req.Id1 = stay.id;
      req.Id2 = accSessions[i].id;
      var res = extra
        ? await AccountingApi.RemoveExtraAccountingSessionFromDomesticStay(req)
        : await AccountingApi.RemoveAccountingSessionFromDomesticStay(req);

      if (res.status == "Success") {
        Swal.fire("Success", `Finished ${i + 1} of ${accSessions.length}`, "success");
        successCount++;
      } else {
        Swal.fire("Failed", `Finished ${i + 1} of ${accSessions.length}`, "error");
        errorCount++;
      }
    }
    Swal.fire("Finished", `Success: ${successCount}, Failed: ${errorCount}`, "success").then(() => {
      setIsLoaded(false);
    });
  };

  const deleteAccountingSession = async (session) => {
    let req = new AddManyToManyReq();
    req.Id1 = stay.id;
    req.Id2 = session.id;
    var res = extra
      ? await AccountingApi.RemoveExtraAccountingSessionFromDomesticStay(req)
      : await AccountingApi.RemoveAccountingSessionFromDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session " + session.id + " Removed",
        icon: "success",
        toast: true,
        position: "bottom-right",
        timer: 1800,
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <SessionsTable
      type="Stay"
      accountingSessions={extra ? stay.getExtraAccountingSessions : stay.getAccountingSessions}
      setIsLoaded={setIsLoaded}
      deleteAccountingSession={deleteAccountingSession}
      batchDeleteAccountingSessions={batchDeleteAccountingSessions}
    />
  );
}
